import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { fetchUserDetails } from "../../../../../Redux/slice/features/authSlice";
import { useSelector } from "react-redux";
import { REACT_APP_API_URL } from "../../../../../env";

const CancelledBookings = () => {
  const [bookings, setBookings] = useState([]);
  const [filteredBookings, setFilteredBookings] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user } = useSelector((state) => state.auth);

  const userId = user?.user.customerId;

  useEffect(() => {
    const fetchCancelledBookings = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${REACT_APP_API_URL}api/dashboard/admin/cancellation-history/${userId}`
        );
        const data = response.data?.data || [];
        setBookings(data);
        setFilteredBookings(data);
        setLoading(false);
      } catch (err) {
        setError(err.message || "Failed to fetch cancelled bookings");
        setLoading(false);
      }
    };

    fetchCancelledBookings();
  }, [userId]);

  useEffect(() => {
    fetchUserDetails();
  }, []);

  const customStyles = {
    rows: {
      style: {
        minHeight: "45px",
      },
    },
    headCells: {
      style: {
        fontWeight: "bold",
        fontSize: "14px",
        textAlign: "center",
        backgroundColor: "#f8f9fa",
        position: "sticky",
        top: 0,
        zIndex: 1,
        whiteSpace: "nowrap",
        overflow: "visible",
        textOverflow: "clip",
      },
    },
    headRow: {
      style: {
        position: "sticky",
        top: 0,
        zIndex: 2,
        backgroundColor: "#f8f9fa",
      },
    },
    cells: {
      style: {
        border: "1px solid #dee2e6",
      },
    },
  };

  useEffect(() => {
    if (fromDate && toDate) {
      const from = new Date(fromDate);
      const to = new Date(toDate);
      const filtered = bookings.filter((booking) => {
        const bookingDate = new Date(booking.dtmCreatedOn);
        return bookingDate >= from && bookingDate <= to;
      });
      setFilteredBookings(filtered);
    } else {
      setFilteredBookings(bookings);
    }
  }, [fromDate, toDate, bookings]);

  const columns = [
    { name: "Cancel ID", selector: (row) => row.intCancelID, sortable: true },
    { name: "Booking ID", selector: (row) => row.intBookingID, sortable: true },
    {
      name: "Booking Amount",
      selector: (row) =>
        `₹${row.dcmBookingAmount != null
          ? row.dcmBookingAmount.toFixed(2)
          : "0.00"
        }`,
      sortable: true,
    },
    {
      name: "Tax Amount",
      selector: (row) =>
        `₹${row.dcmTaxAmount != null ? row.dcmTaxAmount.toFixed(2) : "0.00"}`,
    },
    {
      name: "Cancel Charges",
      selector: (row) =>
        `₹${row.dcmCancelCharges != null
          ? row.dcmCancelCharges.toFixed(2)
          : "0.00"
        }`,
    },
    {
      name: "Refund Amount",
      selector: (row) =>
        `₹${row.dcmRefundAmount != null ? row.dcmRefundAmount.toFixed(2) : "0.00"
        }`,
    },
    {
      name: "Created On",
      selector: (row) => new Date(row.dtmCreatedOn).toLocaleDateString(),
    },
  ];

  if (loading) {
    return (
      <div className="container mt-5 text-center">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mt-5">
        <div className="alert alert-danger">{error}</div>
      </div>
    );
  }

  return (
    <div className="container mt-5">
      <h2 className="mb-3">Cancelled Bookings</h2>
      <div className="card p-3">
        <div className="card-body">
          <div className="row mb-3 border p-2">
            <div className="col-md-4">
              <label>From Date</label>
              <input
                type="date"
                className="form-control"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>
            <div className="col-md-4">
              <label>To Date</label>
              <input
                type="date"
                className="form-control"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>
          </div>

          <DataTable
            columns={columns}
            data={filteredBookings}
            pagination
            paginationPerPage={100}
            paginationRowsPerPageOptions={[50, 100, 500]}
            highlightOnHover
            striped
            persistTableHead
            customStyles={customStyles}
            noDataComponent="No cancelled bookings found."
            fixedHeader
            fixedHeaderScrollHeight="500px"
          />
        </div>
      </div>
    </div>
  );
};

export default CancelledBookings;
